import { Schema } from '@togglecorp/ravl';

const leaveSchema: Schema[] = [
    {
        doc: {
            name: 'leaveType',
            description: 'Leave type schema',
        },
        fields: {
            id: { type: 'uint', required: true },
            name: { type: 'string', required: true },
            numberOfDays: { type: 'number' },
        },
    },
    {
        doc: {
            name: 'leaveTypes',
            description: 'Leave types list',
        },
        fields: {
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.leaveType', required: true },
        },
    },
    {
        doc: {
            name: 'leave',
            description: 'Leave schema',
        },
        fields: {
            id: { type: 'number', required: true },
            createdAt: { type: 'string' },
            modifiedAt: { type: 'string' },
            leaveType: { type: 'number', required: true },
            leaveTypeName: { type: 'string', required: true },
            leaveDays: { type: 'array.string', required: true },
            startDate: { type: 'string', required: true },
            endDate: { type: 'string', required: true },
            purpose: { type: 'string', required: true },
            duration: { type: 'string', required: true },
            approvalStatus: { type: 'string', required: true },
            numberOfDays: { type: 'number', required: true },
            user: { type: 'uint', required: true },
            handoverStaff: { type: 'uint' },
            contactWhileAway: { type: 'uint' },
            supervisor: { type: 'uint' },
        },
    },
    {
        doc: {
            name: 'leaves',
            description: 'Leaves schema',
        },
        fields: {
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.leave', required: true },
        },
    },
    {
        doc: {
            name: 'remainingLeave',
            description: 'Remaining leave schema',
        },
        fields: {
            pendingNumberOfDays: { type: 'number' },
            usedNumberOfDays: { type: 'number' },
            approvedNumberOfDays: { type: 'number' },
            name: { type: 'string' },
            numberOfDays: { type: 'number' },
            totalNumberOfDays: { type: 'number' },
        },
        extends: 'dbentity',
    },
    {
        doc: {
            name: 'remainingLeaves',
            description: 'Remaining Leave list schema',
        },
        fields: {
            // count is not required here
            count: { type: 'uint' },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.remainingLeave', required: true },
        },
    },
];

export default leaveSchema;
